// useLivePricing — fetches all pricing packages grouped by product.
import axios from "axios";
import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cache = { data: null, loaded: false };

export function useLivePricing() {
    const [data, setData] = useState(() => cache.data || {});
    const [loaded, setLoaded] = useState(() => cache.loaded);

    useEffect(() => {
        if (cache.loaded) return;
        let cancelled = false;
        axios
            .get(`${API}/pricing`)
            .then((res) => {
                if (cancelled) return;
                cache.data = res.data || {};
                cache.loaded = true;
                setData(cache.data);
                setLoaded(true);
            })
            .catch(() => {
                if (!cancelled) setLoaded(true);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    // Convenience: get a specific tier
    const tier = (product, tierKey) => {
        const list = data[product] || [];
        return list.find((t) => t.tier_key === tierKey) || null;
    };

    return { data, loaded, tier, byProduct: (p) => data[p] || [] };
}

export function invalidatePricing() {
    cache.data = null;
    cache.loaded = false;
}
